import $ from 'jquery';
import Blazy from 'blazy';

const lazyLoadInit = () => {
    const bLazy = new Blazy({ offset: 150 });

    return bLazy;
};

// doc ready
$(() => {
    // we need to add blazy object instance to global window object
    // for calling revalidate() after AJAX call or UpdatePanel update
    window.BLAZY = lazyLoadInit();

    Sys.WebForms.PageRequestManager.getInstance().add_endRequest(() => {
        const { BLAZY } = window;

        if (BLAZY) {
            // revalidate lazy loading functionality for dynamic images
            BLAZY.revalidate();
        }
    });
});
